import { Loading } from '@components/loadling';
import { GenCtx } from '@hooks/generate';
import { initSdk, onApiError } from '@proccess/api';
import { PATH_AUTH } from '@routes/paths';
import { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
import { isEmpty, isEqual, omit } from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const channel = new BroadcastChannel('auth_channel');

export default GenCtx({
  useLogic: () => {
    const { push } = useRouter();
    const [user, setUser] = useState({
      ...JSON.parse(localStorage.getItem('auth') || '{}'),
    } as ISignIn);
    const [role, setRole] = useState<'isAdmin' | 'isDoctor' | string>('isAdmin');

    async function onSignOut(cb?: () => Promise<void> | void) {
      try {
        channel.postMessage({ type: 'LOGOUT' });
        push(PATH_AUTH.login);
        setUser({});
        setRole('isAdmin');
        Cookies.remove('jwt');
        localStorage.clear();
        Loading.Hide();
        cb?.();
      } catch (error) {
        onApiError(error);
      }
    }

    async function onSignIn(payload: { username: string; password: string }) {
      try {
        Loading.Show();

        let url = '';

        if (isEqual(role, 'isDoctor')) {
          url = '/employee/doctor_users/sign_in';
        } else {
          url = '/admin/admin_users/sign_in';
        }

        const { data }: AxiosResponse<ISignIn> = await initSdk.post(url, {
          ...payload,
        });

        if (data) {
          setUser(data);
          Cookies.set('jwt', String(data?.auth_token));
          localStorage.setItem('auth', JSON.stringify(omit(data, 'auth_token')));
          window.dispatchEvent(new Event('loginSuccess'));
          push('/');
          channel.postMessage({ type: 'LOGIN', data });
        }
      } catch (error) {
        onApiError(error);
      } finally {
        Loading.Hide();
      }
    }

    useEffect(() => {
      const storedAuth = JSON.parse(localStorage.getItem('auth') || '{}');
      if (isEmpty(storedAuth)) {
        push(PATH_AUTH.login);
      } else {
        setUser(storedAuth);
      }
    }, []);

    useEffect(() => {
      channel.onmessage = (event) => {
        if (event.data?.type === 'LOGIN') {
          const data = event.data?.data as ISignIn;
          setUser(data);
          Cookies.set('jwt', String(data?.auth_token));
          localStorage.setItem('auth', JSON.stringify(omit(data, 'auth_token')));
          window.dispatchEvent(new Event('loginSuccess'));
          push('/');
          Loading.Hide();
        }

        if (event.data?.type === 'LOGOUT') {
          push(PATH_AUTH.login);
          setUser({});
          setRole('isAdmin');
          Cookies.remove('jwt');
          localStorage.clear();
          Loading.Hide();
        }
      };
      return () => {
        channel.onmessage = null;
      };
    }, []);

    return {
      user,
      role,
      setRole,
      setUser,
      fncs: { onSignIn, onSignOut },
    };
  },
});
